var React = require('react');

function ChevronDown (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M0,4.974,4.853,0,9.719,4.974","transform":"translate(10.434 5.673) rotate(-180)","fill":"none","stroke":"#fff","strokeWidth":"2"}));
}

ChevronDown.defaultProps = {"width":"11.149","height":"7.104","viewBox":"0 0 11.149 7.104"};

module.exports = ChevronDown;

ChevronDown.default = ChevronDown;
